
















import { Component, Mixins, PropSync } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'

@Component
export default class SelectFilter extends Mixins(BaseVue) {
  @PropSync('value', { type: Array })
  selectedValues!: Array<any>
}
